<template>
  <div class="container horizontal">
    <ItemList :itemID="itemID" :headless="true" childFilter="taskLike" />
  </div>
</template>

<style scoped>
.container {
  display: flex;
  flex-direction: row;
  margin: var(--basic-margin);
}
.container::v-deep .card {
  border: var(--task-border);
}
.elements {
  gap: 0;
}
</style>

<script>
import { getItem } from "@/reactive-cache";
import ItemList from "@/components/ItemList.vue";

export default {
  props: ["itemID"],
  components: {
    ItemList,
  },
  computed: {
    item() {
      return getItem(this.itemID);
    },
    ListLikeChildren() {
      return this.item.getListLikeChildren();
    },
  },
  methods: {},
};
</script>
